import React from 'react'
import CFooter from 'lemon-campaign-ui/lib/molecules/Footer'
import { graphql, StaticQuery } from 'gatsby'
import get from 'lodash/get'

const Footer = ({ component, defaults, data }) => {
  const utm_campaign = get(data, 'campaignData.companyId')
  const utm_term = get(data, 'campaignData._id')
  const utmParams = `?utm_source=badge-footer&utm_medium=perspective-badge&utm_campaign=${utm_campaign}&utm_term=${utm_term}`

  return (
    <CFooter
      {...defaults}

      bgColorReference={data.campaignData.themeId.backgroundColor}
      branding={component.content.branding}

      termsLink={component.content.termsLink}
      legalLink={component.content.legalLink}

      termsText={component.content.termsText}
      legalText={component.content.legalText}

      utmParams={utmParams}
    />
  )
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        campaignData {
          _id
          companyId
          themeId {
            backgroundColor
          }
        }
      }
    `}
    render={data => <Footer data={data} {...props} />}
  />
)

